import type { CSSProperties } from 'react'
import type { CiEdge } from '../api/cmdb'

/**
 * Numele relatiei unui rand din Connections, cu SAGEATA de sens in fata.
 *
 * Cardul Connections tine iesitoarele si intratele in ACELASI tabel (cum il
 * are `view.php`, cerinta 38). Pana acum sensul il spunea numai cuvantul:
 * "Runs on" la iesitoare, numele invers "Hosts" la intrate. Un tip fara nume
 * invers scris lasa randul intrat fara cuvant, deci fara sens. Acum:
 *
 *  - `→` = elementul acesta e SURSA muchiei (iesitoare), `←` = e TINTA ei;
 *  - `title` spune in cuvinte cine catre cine, cu numele celuilalt capat;
 *  - un text ascuns vizual o spune si cititorului de ecran (sageata e
 *    `aria-hidden`: "leftwards arrow" nu spune nimic);
 *  - numele de rezerva vine gata de pe server (`CmdbRelations::incoming()`
 *    pune numele direct cand lipseste cel invers), deci "← Depends on" se
 *    citeste corect: celalalt depinde de elementul acesta.
 */
const HIDDEN: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
}

export function edgeTitle(edge: Pick<CiEdge, 'direction' | 'itemName'>): string {
  return edge.direction === 'out'
    ? `This item → ${edge.itemName || 'other'}`
    : `${edge.itemName || 'Other'} → this item`
}

export function EdgeRelation({ edge }: { edge: Pick<CiEdge, 'direction' | 'relation' | 'itemName'> }) {
  const out = edge.direction === 'out'
  return (
    <span className="cmdb-edge-relation" data-direction={out ? 'out' : 'in'} title={edgeTitle(edge)}>
      <span className="cmdb-edge-arrow" aria-hidden="true" style={{ fontWeight: 600, marginRight: 4 }}>
        {out ? '→' : '←'}
      </span>
      <span style={HIDDEN}>{out ? 'Outgoing: ' : 'Incoming: '}</span>
      {edge.relation}
    </span>
  )
}
